import React, { Component } from 'react'
import { Button, Container, Col, Row, Form, FormGroup, Input } from 'reactstrap'
import { toast } from 'react-toastify'
import { connect } from 'react-redux'
import _get from 'lodash.get'
import _debounce from 'lodash.debounce'

import { company } from 'api'
import assignationAPI from 'api/assignation'

import SidePopup from 'components/SidePopupNew'
import OperatorAssignCard from './OperatorAssignCard'
import { isToMany } from 'utils/channelsUtils'
import { BrandsAndDelegations, ButtonTag, SelectWithLabel, Button as ButtonNormal } from 'components/Form'
import { activeUserAct } from 'redux/actions'
import './style.scss'
import Nixi1Spinner from 'components/Nixi1Spinner'
import { lang } from 'utils/helpers'

const apiAssignationsUsers = company.assignationsUsers

class AssignOperator extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      operators: [],
      allowToMany: false,
      total: 0,
      filters: {
        roles: [],
        brands: [],
        delegations: [],
      },
      confirmationDialog: false,
      appliedFilters: {
        roles: [],
        brands: [],
        delegations: [],
        text: '',
      },
      assignedOperators: [],
      brandDefault: [],
      delegationDefault: [],
      brandNew: [],
      delegationNew: [],
      isSubmitting: false,
      brandsOptions: [],
      delegationsOptions: [],
    }

    this.searchDebounce = _debounce(this.getAvailableOperators.bind(this), 250)
  }

  componentDidMount() {
    const { user: { assignedTo = [], channels, brand, delegation }, company } = this.props


    this.setState({
      assignedOperators: assignedTo,
      allowToMany: isToMany(company, _get(channels, '0.token')),
      brandDefault: [{ value: brand }],
      delegationDefault: [{ value: delegation }],
      brandNew: [{ value: brand }],
      delegationNew: [{ value: delegation }],
    })
    this.getAvailableOperators({ getFilters: true })

  }

  getAvailableOperators = (filters) => {
    if (filters.brands) filters.brands = filters.brands.map((elem) => elem.value || elem)
    if (filters.delegations) filters.delegations = filters.delegations.map((elem) => elem.value || elem)
    if (filters.roles) filters.roles = filters.roles.map((elem) => elem.value || elem)

    assignationAPI
      .getAvailableOperators({ ...filters, size: 2000, withVirtualOp: true })
      .then(({ data }) => {
        const { total, operators, filters: filtersData } = data
        if (filters.getFilters) {
          this.setState({
            total,
            filters: filtersData,
            operators,
            brandsOptions: filtersData.brands,
            delegationsOptions: filtersData.delegations
          }) //loading: true
        } else {
          this.setState({ total, operators }) // loading: true
        }
        this.setState({ loading: false })
      })
      .catch((error) => {
        console.error(error)

        this.setState({ total: 0, operators: [], loading: false })
      })
  }

  onChange = (type) => (value) => {
    const { appliedFilters } = this.state

    const _value = (Array.isArray(value) && value.length === 0) ? null : value

    const filters = {
      ...appliedFilters,
      [type]: _value ? [_value] : [],
    }

    if (type === 'brands') {
      //const brandId = _get(appliedFilters, 'brands.0.value')
      filters.delegations = []
      //if (brandId !== _get(_value, 'value')) {filters.delegations = []
    }

    this.setState({ appliedFilters: { ...filters } })
    this.getAvailableOperators(filters)
  }

  onChangeText = ({ target: { value } }) => {
    const { appliedFilters } = this.state

    this.setState({ appliedFilters: { ...appliedFilters, text: value } })

    if (value.length > 2 || value.length === 0) {
      this.searchDebounce({ ...appliedFilters, text: value })
    }
  }

  assignOperator = () => {
    const { user, activeOperator } = this.props
    const { assignedOperators } = this.state

    apiAssignationsUsers
      .add({
        userId: user.id,
        operator: { id: activeOperator._id, company: user.company },
        operatorIds: assignedOperators,
      })
      .then(({ data }) => {
        if (data.statusOk) {
          // this.props.onAssign({ ...data.results }, true)
          toast(lang('dashboard_assigned-conversation'), { position: 'top-center' })
        }
      })
      .catch(console.error)
  }

  deleteAssignation = (operatorIds, openModal) => {
    const { user, activeOperator } = this.props

    apiAssignationsUsers
      .remove({
        userId: user.id,
        operator: { id: activeOperator._id, company: user.company },
        operatorIds,
      })
      .then(({ data }) => {
        if (data.statusOk) {
          // this.props.onDeleteAssignation({ ...data.results }, openModal)
          toast(lang('dashboard_unassigned-conversation'), { position: 'top-center' })
        }
      })
      .catch(console.error)
  }

  selectOperator = (operatorId, type) => {
    const { user: { assignedTo } } = this.props
    const { assignedOperators, allowToMany } = this.state

    if (assignedOperators.includes(operatorId)) {
      this.setState({ assignedOperators: assignedOperators.filter((item) => item !== operatorId) })

      if (assignedTo.includes(operatorId)) {
        this.deleteAssignation([operatorId], true)
      }
    } else {
      if (allowToMany)
        this.setState({ assignedOperators: assignedOperators.concat(operatorId) })
      else
        this.setState({ assignedOperators: [operatorId] })
    }

    setTimeout(() => {
      type === 'add' && this.assignOperator()// : this.toggleConfirmationDialog()
    }, 10)
  }

  toggleConfirmationDialog = () => {
    this.setState((prevState) => ({ confirmationDialog: !prevState.confirmationDialog }))
  }

  onAssign = async () => {
    if (this.state.brandNew.length > 0 && this.state.delegationNew.length > 0) {
      this.setState({ isSubmitting: true })
      await this.props.dispatch(activeUserAct.updateUser({
        ...this.props.user,
        brand: this.state.brandNew[0].value,
        delegation: this.state.delegationNew[0].value
      }))
      this.setState({ brandDefault: this.state.brandNew, delegationDefault: this.state.delegationNew })
      this.setState({ isSubmitting: false })

      this.props.getSetting(this.props.user.id)
      toast(lang('dashboard_assigned-delegation'), { position: 'top-center' })
    }
  }

  allowAssign = () => {
    try {
      if (this.state.brandDefault[0].value === this.state.brandNew[0].value
        && this.state.delegationDefault[0].value === this.state.delegationNew[0].value) {
        return true
      }
      else if (this.state.brandNew.length === 0 || this.state.delegationNew.length === 0)
        return true
      else return false
    } catch (error) {
      console.error(error)
    }
  }

  render() {
    const { onHide, user } = this.props
    const { loading, filters, appliedFilters, operators, total, assignedOperators = [], confirmationDialog } = this.state
    const delegations = appliedFilters.delegations.length ? [filters.delegations.find((elem) => elem._id === appliedFilters.delegations[0].value)] : []
    const brands = appliedFilters.brands.length > 0 ? [filters.brands.find((elem) => elem._id === appliedFilters.brands[0].value)] : []
    const role = appliedFilters.roles.length > 0 ? appliedFilters.roles : []

    return (
      <SidePopup
        header={lang('dashboard_assignments-panel')}
        closeButton={false}
        onHide={onHide}
        confirmationDialog={
          confirmationDialog ? (
            <Container>
              <Row>
                <Col>
                  <h3 className='mb-3'>{lang('dashboard_youre-sure')}</h3>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Button onClick={this.toggleConfirmationDialog} color='default'>
                    {lang('dashboard_cancel')}
                  </Button>
                </Col>
                <Col className='text-right'>
                  <Button onClick={() => this.deleteAssignation(user.assignedTo)} color='danger'>
                    {lang('dashboard_delete')}
                  </Button>
                </Col>
              </Row>
            </Container>
          ) : null
        }
      >
        {loading
          ? <div className='containerSpinner'> <Nixi1Spinner height='80vh' width='15%'/> </div>
          //<Spinner height='85vh' />
          :
          <div className='assignation-user-container fadeIn animated'>

            <div className='section-subtitle'>{lang('dashboard_assign-delegation')}</div>

            <FormGroup className='section-search'>
              <BrandsAndDelegations
                onChangeBrands={(brand) => this.setState({ brandNew: [{ label: brand.label, value: brand.value }], delegationNew: [] })}
                currentBrands={this.state.brandNew || []}
                newBrands={this.state.brandsOptions}
                onChangeDelegations={(delegation) => this.setState({ delegationNew: [{ label: delegation.label, value: delegation.value }] })}
                currentDelegations={this.state.delegationNew || []}
                newDelegations={this.state.delegationsOptions}
                multi={false}
                displayAllValues={false}
              />
              <ButtonNormal
                disabled={this.allowAssign()}
                secondary={!this.allowAssign()}
                value={lang('dashboard_assign')}
                className='aop-assign-delegation-btn'
                isSubmitting={this.state.isSubmitting}
                onClick={this.onAssign}
              />

              <ButtonNormal
                onClick={()=> this.setState({ brandNew: this.state.brandDefault, delegationNew: this.state.delegationDefault })}
                className='button-reset'
              >
                <i className='fa fa-undo' />
              </ButtonNormal>
            </FormGroup>

            <div className='section-subtitle section-subtitle-2'>{lang('dashboard_assign-operator')}</div>


            <Form>
              <FormGroup className='section-search'>
                <div className='sidemenu-search-text input-search-wrapper'>
                  <i className='fa fa-search'/>
                  <Input placeholder={lang('dashboard_search')} onChange={this.onChangeText} value={this.state.appliedFilters.text} />
                </div>
                <div>
                  <SelectWithLabel
                    name='role'
                    key='role'
                    placeholder={lang('dashboard_selector_filter-by-role')}
                    classNameWrapper='select-roles'
                    options={filters.roles.map((elem) => ({ value: elem, label: lang(`roles_${elem}`) }))}
                    value={role}
                    onChange={this.onChange('roles')}
                    isClearable
                  />
                </div>
              </FormGroup>
              <FormGroup className='section-search'>
                <BrandsAndDelegations
                  onChangeBrands={this.onChange('brands')}
                  currentBrands={brands.length > 0 ? [{ value: brands[0]._id, label: brands[0].name }] : []}
                  newBrands={this.state.brandsOptions}
                  onChangeDelegations={this.onChange('delegations')}
                  currentDelegations={delegations.length > 0 ? [{ value: delegations[0]._id, label: delegations[0].name }] : []}
                  newDelegations={this.state.delegationsOptions}
                  multi={false}
                  displayAllValues={false}
                  isClearable
                />
                <ButtonTag
                  value={lang('dashboard_reset-filters')}
                  onClick={()=> {
                    const appliedFilters = {
                      roles: [],
                      brands: [],
                      delegations: [],
                      text: '',
                    }
                    this.setState({ appliedFilters: appliedFilters })
                    this.getAvailableOperators(appliedFilters)
                  }}
                />
              </FormGroup>
            </Form>

            <div className='users-to-assign-wrapper'>
              <div className='section-subtitle-inner'>{`${lang('dashboard_assigned-operators')} (${assignedOperators.length})`}</div>
              <div className='users-to-assign' style={{ maxHeight: 200 }}>
                {total > 0 && (
                  assignedOperators.map((_id) => {
                    const operator = operators.find(op => op._id === _id)

                    if (!operator) return null
                    return (
                      <OperatorAssignCard
                        key={operator._id}
                        id={operator._id}
                        operator={operator}
                        onSelected={this.selectOperator}
                        onDelete
                        isAction
                      />
                    )})
                )}
              </div>
            </div>


            <div className='users-to-assign-wrapper'>
              <div className='section-subtitle-inner'>{assignedOperators.length > 0 ? lang('dashboard_add-operator') : lang('dashboard_assign-operator')}</div>
              <div className='users-to-assign'>
                {total > 0 ? (
                  operators.map((operator) => {
                    if (!assignedOperators.includes(operator._id) && operator.role !== 'virtual')
                      return (
                        <OperatorAssignCard
                          key={operator._id}
                          id={operator._id}
                          operator={operator}
                          onSelected={this.selectOperator}
                          isAction
                        />
                      )
                    else
                      return null
                  })
                ) : (
                  <div className={'assignation-user-not-found py-2 pl-2'}>{lang('dashboard_no-results-with-filters')}</div>
                )}
              </div>
            </div>
          </div>
        }
      </SidePopup>
    )
  }
}

export default connect((state) => ({
  roles: state.roles.filter((elem) => elem !== 'comunityManager'),
  activeOperator: state.user,
  company: state.companies
}))(AssignOperator)
